// hooks/useProgressLineActivityListData.ts
import { getProgressLineActivity } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo, useState, useCallback } from 'react';

const useProgressLineActivityListData = (startDate: string, endDate: string) => {
    const [search, setSearch] = useState('');

    const changeSearch = useCallback((val: string) => {
        setSearch(val);
    }, []);

    const query = useDataQuery(['progress-line-activity', startDate, endDate], () =>
        getProgressLineActivity(startDate, endDate)
    );

    const allData = query.data || [];

    const filteredData = useMemo(() => {
        if (!search) return allData;
        return allData.filter((item: any) => item.caption?.toLowerCase().includes(search.toLowerCase()));
    }, [allData, search]);

    return {
        data: filteredData,
        isLoading: query.isLoading,
        search,
        changeSearch,
    };
};

export default useProgressLineActivityListData;
